
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 56 54.25"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M29.75 54.25h-14A5.256 5.256 0 0110.5 49V21a12.247 12.247 0 015.25-10V7a1.751 1.751 0 011.75-1.75H28A1.751 1.751 0 0129.75 7v4A12.246 12.246 0 0135 21v28a5.256 5.256 0 01-5.25 5.25zm-10.5-45.5v3.208a1.749 1.749 0 01-.879 1.518A8.732 8.732 0 0014 21.004v28a1.752 1.752 0 001.75 1.75h14a1.752 1.752 0 001.75-1.75v-28a8.729 8.729 0 00-4.371-7.524 1.749 1.749 0 01-.879-1.518V8.75zm35 5.25a1.69 1.69 0 01-.174-.009l-17.5-1.75A1.75 1.75 0 0135 10.5v-7a1.75 1.75 0 011.576-1.741l17.5-1.75A1.751 1.751 0 0156 1.75v10.5A1.751 1.751 0 0154.25 14zM38.5 8.917l14 1.4V3.684l-14 1.4z"}}),_c('path',{staticClass:"a",attrs:{"d":"M1.75 47.25A1.75 1.75 0 010 45.5V21A15.767 15.767 0 0115.75 5.25h21a1.75 1.75 0 010 3.5h-21A12.263 12.263 0 003.5 21v24.5a1.75 1.75 0 01-1.75 1.75z"}}),_c('path',{staticClass:"a",attrs:{"d":"M19.249 8.75A1.743 1.743 0 0118.2 8.4l-7-5.25a1.75 1.75 0 012.1-2.8l7 5.25a1.75 1.75 0 01-1.051 3.15zm14.001 35h-10.5A1.75 1.75 0 0121 42V24.5a1.751 1.751 0 011.75-1.75h10.5a1.75 1.75 0 010 3.5H24.5v14h8.75a1.75 1.75 0 010 3.5z"}})])
          )
        }
      }
    